import { useAppSelector } from "@/app/appStore";
import { selectCurrentCamera } from "@/entities/annotation";
import { HAND_IDS } from "@/entities/annotation/model/consts";
import { selectSelectedClosestGondolaDistItem } from "@/entities/gondola-change-groups";
import { CAMERA_FRAME_IMAGE_SIZE } from "@/shared/consts";
import { useMemo } from "react";
import { Circle } from "react-konva";
import { useMediaState } from "@tezzro/player";

const WristPoint = () => {
  const selectedClosestGondolaDistItem = useAppSelector(
    selectSelectedClosestGondolaDistItem
  );
  const currentCamera = useAppSelector(selectCurrentCamera);
  const lastStoppedTime = useMediaState("lastStoppedTime");
  const canvasDimensions = useAppSelector(
    (state) => state.annotation.canvasDimensions
  );

  const wristPoint = useMemo(() => {
    if (!selectedClosestGondolaDistItem || !currentCamera || !lastStoppedTime) {
      return null;
    }

    const selectedItemTimeMs = new Date(
      selectedClosestGondolaDistItem.timestamp
    ).getTime();

    if (lastStoppedTime !== selectedItemTimeMs) {
      return null;
    }

    return (
      selectedClosestGondolaDistItem.projected_wrist_points_2d_per_cam[
        currentCamera
      ] || null
    );
  }, [selectedClosestGondolaDistItem, currentCamera, lastStoppedTime]);

  const positionedWristPoint = useMemo(() => {
    if (!wristPoint) return null;

    const radius = 3;
    const scaleX = canvasDimensions.width / CAMERA_FRAME_IMAGE_SIZE.width;
    const scaleY = canvasDimensions.height / CAMERA_FRAME_IMAGE_SIZE.height;

    return {
      x: Math.round(wristPoint[0] * scaleX - radius),
      y: Math.round(wristPoint[1] * scaleY - radius),
      size: radius * 2,
    };
  }, [canvasDimensions, wristPoint]);

  return (
    <Circle
      x={positionedWristPoint?.x}
      y={positionedWristPoint?.y}
      radius={positionedWristPoint?.size}
      fill={
        selectedClosestGondolaDistItem?.hand_id === HAND_IDS.LEFT
          ? "#3b82f6"
          : "#ef4444"
      }
      strokeWidth={4}
      stroke="#ffffff"
    />
  );
};

export default WristPoint;
